export default __webpack_public_path__ + "static/media/s1.f968c129.jpg";